import { AUTH_SOURCE } from "../constants/authSource";

/**
 * API base URL constants and pure getters (no store dependency).
 * Single source of truth for Reporting and Study microservice URLs.
 *
 * We keep one env for the host only:
 *   REACT_APP_BASE_URL = https://devvetsapimanagement.azure-api.net
 *   REACT_APP_BASE_URL = https://prodradsforvetswebapp-reporting.azurewebsites.net
 *
 * Code here appends the fixed microservice paths on top of that host
 * (R4V, CRE, Video). To change domains per deployment, set REACT_APP_BASE_URL when building.
 */


// CRA exposes only REACT_APP_* to the frontend.
export const BASE_URL =
  (process.env.REACT_APP_BASE_URL || "").replace(/\/+$/, "")

// Radical Reporting microservice (R4V) uses the configurable host
const DEV_REPORTING_R4V = `${BASE_URL}/ReportingMicroservice`;
const DEV_STUDY_R4V = `${BASE_URL}/StudyMicroservice`;

// CRE hospital microservices (same host as R4V via REACT_APP_BASE_URL)
const DEV_REPORTING_CRE = `${BASE_URL}/CreReportingMicroservice`;
const DEV_STUDY_CRE = `${BASE_URL}/CreStudyMicroservice`;

// Video microservice base URL (shared across auth types)
const DEV_VIDEO = `${BASE_URL}/VideoMicroservice/api/ReportsVideo`;

/**
 * Reporting + Study base URLs for an auth channel (CRE / R4V).
 * @param {string|null|undefined} authSource — AUTH_SOURCE value
 * @returns {{ reporting: string, study: string }}
 */
export function getApiBaseUrlsForAuth(authSource) {
  switch (authSource) {
    case AUTH_SOURCE.CRE:
      return { reporting: DEV_REPORTING_CRE, study: DEV_STUDY_CRE };
    case AUTH_SOURCE.RADICAL:
    default:
      return { reporting: DEV_REPORTING_R4V, study: DEV_STUDY_R4V };
  }
}

/**
 * Video microservice base URL.
 * No store dependency — safe to use anywhere.
 */
export function getVideoApiBaseUrl() {
  return DEV_VIDEO;
}

export const API_BASE_URLS = {
  reportingR4V: DEV_REPORTING_R4V,
  reportingCre: DEV_REPORTING_CRE,
  studyR4V: DEV_STUDY_R4V,
  studyCre: DEV_STUDY_CRE,
  video: DEV_VIDEO,
};
